// extracted by mini-css-extract-plugin
export default {"container":"aae79b67"};